export enum Environment {
    development = 'development',
    beta = 'beta',
    staging = 'staging',
    production = 'production'
}